var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStraightConnector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 22,
  fill: "none",
  preserveAspectRatio: "none",
  viewBox: "0 0 214 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#53565B",
  fillOpacity: 0.2,
  d: "M0 21.5V.5h213.5v21H0Z"
})));
export { SvgStraightConnector as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjIyIiB2aWV3Qm94PSIwIDAgMjE0IDIyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPgo8cGF0aCBkPSJNMCAyMS41VjAuNTAwMDA5TDIxMy41IDAuNVYyMS41TDAgMjEuNVoiIGZpbGw9IiM1MzU2NUIiIGZpbGwtb3BhY2l0eT0iMC4yIi8+Cjwvc3ZnPgo=";